import * as React from 'react';
import SVGInline from 'react-svg-inline';

import { StatisticsLocale } from './statistics.locale';
import styles from './Statistics.scss';

import networkIcon from '../../Icon/network.svg';
import portsIcon from '../../Icon/ports.svg';
import trafficIcon from '../../Icon/traffic.svg';
import { withRouteData } from 'react-static';
import { Statistics, StatisticsKeys } from '../../../containers/HomePage/Statistics/Statistics';

interface StatisticsProps {
  statisticsLocale: StatisticsLocale;
  statistics: Statistics;
}

const statisticsIcons: { [key in StatisticsKeys]: string } = {
  networksCount: networkIcon,
  trafficPeak: trafficIcon,
  portsCount1G: portsIcon,
  portsCount10G: portsIcon,
  portsCount100G: portsIcon,
  portsCount400G: portsIcon,
};

const Statistics: React.SFC<StatisticsProps> = ({ statisticsLocale, statistics }) => (
  <div className="container">
    <h4 className={styles.sectionTitle}>{statisticsLocale.title}</h4>
    <div className={styles.itemsContainer}>
      {Object.entries(statisticsLocale.statistics).map(([key, description]) => (
        <div className={styles.item} key={key}>
          <SVGInline svg={statisticsIcons[key]} className={styles.icon} />
          <div className={styles.textCol}>
            <span className={styles.title}>
              {statistics[key] > 1000 ? statistics[key] / 1000 : statistics[key]}
              {key === StatisticsKeys.trafficPeak && ` ${statistics[key] > 1000 ? 'T' : 'G'}bps`}
              {(key === StatisticsKeys.portsCount1G ||
                key === StatisticsKeys.portsCount10G ||
                key === StatisticsKeys.portsCount100G ||
                key === StatisticsKeys.portsCount400G) &&
                'x'}
            </span>
            <span className={styles.description}>{description}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default withRouteData(Statistics);



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/Statistics/Statistics.tsx